var map = {
	"./default/components/app/AppFooter": "ccd9",
	"./default/components/app/AppFooter.vue": "ccd9",
	"./default/components/app/AppToolbar": "7ef3",
	"./default/components/app/AppToolbar.vue": "7ef3",
	"./default/components/common/icons/SynthesisIcon": "1730",
	"./default/components/common/icons/SynthesisIcon.vue": "1730",
	"./default/components/widgets/LangSwitch": "eb74",
	"./default/components/widgets/LangSwitch.vue": "eb74",
	"./default/layouts/DefaultLayout": "4598",
	"./default/layouts/DefaultLayout.vue": "4598",
	"./default/views/about/About": "1014",
	"./default/views/about/About.vue": "1014",
	"./default/views/case-studies/CaseStudies": "c9bf",
	"./default/views/case-studies/CaseStudies.vue": "c9bf",
	"./default/views/contact/ContactDialog": "2796",
	"./default/views/contact/ContactDialog.vue": "2796",
	"./default/views/contact/ContactForm": "8c57",
	"./default/views/contact/ContactForm.vue": "8c57",
	"./default/views/home/BenchmarkBarChart": "6b4e",
	"./default/views/home/BenchmarkBarChart.vue": "6b4e",
	"./default/views/home/HedgingPositionsChart": "d3eb",
	"./default/views/home/HedgingPositionsChart.vue": "d3eb",
	"./default/views/home/Home": "9e1d",
	"./default/views/home/Home.vue": "9e1d",
	"./default/views/home/OptimalHedgeChart": "20c1",
	"./default/views/home/OptimalHedgeChart.vue": "20c1",
	"./default/views/home/RiskDonutChart": "667a",
	"./default/views/home/RiskDonutChart.vue": "667a",
	"./default/views/press/Press": "afe8",
	"./default/views/press/Press.vue": "afe8",
	"./default/views/press/PressArticle": "c91c",
	"./default/views/press/PressArticle.vue": "c91c",
	"./default/views/press/RecentArticles": "b291",
	"./default/views/press/RecentArticles.vue": "b291"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "cb5d";
module.exports = webpackAsyncContext;